import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchCategories } from "@/lib/api";

const CategoriesContext = createContext(null);

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchCategories(true);
      setCategories(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const byKey = (key) => categories.find((c) => c.key === key);
  const nameFor = (key, lang) => {
    const c = byKey(key);
    if (!c) return key;
    return lang === "ar" ? c.name_ar : c.name_en;
  };

  return (
    <CategoriesContext.Provider value={{ categories, loading, reload, byKey, nameFor }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export const useCategories = () => useContext(CategoriesContext);
